<template>
  <div>
    <a-modal
      v-model="visible"
      title="管理员批量补签（培训补签）"
      centered
      :keyboard="false"
      :maskClosable="false"
      width="auto"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model ref="ruleForm">
        <a-form-model-item ref="jyr1" prop="jyr1">
          <FormItem label="公司负责人签字">
            <div
              class="content"
              @click="type = 1"
              :class="{ active: type == 1 }"
            >
              <div class="msg" v-if="!dataForm.jyr1">请签字</div>
              <img
                v-else
                :src="dataForm.jyr1"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
          </FormItem>
        </a-form-model-item>
        <a-form-model-item ref="jyr2" prop="jyr2">
          <FormItem label="项目部负责人签字">
            <div
              class="content"
              @click="type = 2"
              :class="{ active: type == 2 }"
            >
              <div class="msg" v-if="!dataForm.jyr2">请签字</div>
              <img
                v-else
                :src="dataForm.jyr2"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
          </FormItem>
        </a-form-model-item>
        <a-form-model-item ref="jyr3" prop="jyr3">
          <FormItem label="班组签字">
            <div
              class="content"
              @click="type = 3"
              :class="{ active: type == 3 }"
            >
              <div class="msg" v-if="!dataForm.jyr3">请签字</div>
              <img
                v-else
                :src="dataForm.jyr3"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
          </FormItem>
        </a-form-model-item>
      </a-form-model>
      <div slot="footer">
        <a-button @click="startSign" v-if="!readonly">{{
          type == 1 && dataForm.jyr1
            ? "再次签字"
            : type == 2 && dataForm.jyr2
            ? "再次签字"
            : type == 3 && dataForm.jyr3
            ? "再次签字"
            : "开始签字"
        }}</a-button>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="confirm" :loading="confirmLoading"
          >完成</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import FormItem from "@/components/FormItem/index";
import SignClient from "@/utils/sign/index";
import { dataURLtoBlob } from "@/utils/os";
import { upload } from "@/request/sys";
export default {
  components: { FormItem },
  data() {
    return {
      visible: false,
      type: 1,
      dataForm: {
        jyr1: "",
        jyr2: "",
        jyr3: "",
      },
      Sign: null,
      readonly: false,
      confirmLoading: false,
    };
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    init(e) {
      if (!!e && !!e.jyr1 && !!e.jyr2 && !!e.jyr3) {
        this.dataForm.jyr1 = e.jyr1;
        this.dataForm.jyr2 = e.jyr2;
        this.dataForm.jyr3 = e.jyr3;
        this.readonly = true;
      }
      this.visible = true;
    },
    destroy() {
      if (this.Sign) {
        this.Sign.close();
      }
    },
    handleCancel() {
      this.visible = false;
      this.dataForm.jyr1 = "";
      this.dataForm.jyr2 = "";
      this.dataForm.jyr3 = "";
      this.readonly = false;
      if (this.Sign) this.Sign.isPolling = false;
    },
    //初始化签字板
    startSign() {
      if (!this.Sign) {
        this.Sign = new SignClient();
        this.Sign.setInitokCallback(() => {
          this.$message.success("请开始签字");
        });
        this.Sign.setInkCallback((base64) => {
          if (this.type == 1) this.dataForm.jyr1 = base64;
          if (this.type == 2) this.dataForm.jyr2 = base64;
          if (this.type == 3) this.dataForm.jyr3 = base64;
        });
        this.Sign.setErrCallback((res) => {
          this.$error({
            centered: true,
            title: "温馨提示",
            getContainer: ()=> document.getElementById("bodyContnet"),
            content: res.message,
            onOk: () => {
              // this.handleCancel();
            },
          });
        });
      }
      this.Sign.initDevice();
    },
    confirm() {
      if (!this.dataForm.jyr1)
        return this.$message.$error("请进行公司负责人签字");
      if (!this.dataForm.jyr2)
        return this.$message.$error("请进行项目部负责人签字");
      if (!this.dataForm.jyr3) return this.$message.$error("请进行班组签字");
      this.Sign.isPolling = false;
      let p = Promise.all([
        this.base64Upload(this.dataForm.jyr1),
        this.base64Upload(this.dataForm.jyr2),
        this.base64Upload(this.dataForm.jyr3),
      ]);
      this.confirmLoading = true;
      p.then((res) => {
        console.log(res);
        this.$emit("jyrok", {
          jyr1: res[0].data.url,
          jyr2: res[1].data.url,
          jyr3: res[2].data.url,
        });
        this.handleCancel();
      }).finally(() => {
        this.confirmLoading = false;
      });
    },
    //base64图片上传服务器返回url地址
    base64Upload(base64, name = "文件名称") {
      return new Promise((resovle, reject) => {
        if (base64.indexOf("http://") > -1 || base64.indexOf("https://") > -1) {
          return resovle({ data: { url: base64 } });
        }
        const file = dataURLtoBlob(base64, encodeURIComponent(name));
        let formData = new FormData();
        formData.append("file", file);
        upload(formData)
          .then((res) => {
            resovle(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.content {
  width: 387px;
  height: 244px;
  border: 1px solid #f5f6fa;
  /* margin: 10px 0; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.active {
  border: 1px solid #0073ff;
}
.msg {
  font-size: 30px;
  line-height: 20px;
  color: #b9d5fd;
}
</style>